import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { ShowMultiLine } from "../../../common/controls";
import { ShowBoolean } from "../../../common/controls";
import { InputCodeEditor } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type ThemeViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  nameValue?: { displayId: string; id: string } | null;
  name: string;
  activeValue?: { displayId: string; id: string } | null;
  active: boolean;
  authoringValue?: { displayId: string; id: string } | null;
  authoring: string;
  resolvedValue?: { displayId: string; id: string } | null;
  resolved: string;
};

export const ThemeViewForm: React.FC<ThemeViewFormProps> = observer(
  ({
    onPrint = () => {},
    onCancel = () => {},
    onEdit,
    showToolbox = true,
    name = "",
    active = false,
    authoring = "{}",
    resolved = "{}",
  }) => {
    const rootStore = useRootStore();
    const { langStore } = rootStore;

    const componentRef = useRef(null);
    const handlePrint = useReactToPrint({
      content: () => componentRef.current,
    });

    return (
      <Grid>
        {showToolbox && (
          <FormToolbox
            editForm={onEdit}
            printForm={() => onPrint(handlePrint)}
            closeForm={() => onCancel()}
          />
        )}
        <Box ref={componentRef}>
          <GroupContainer
            id="null"
            title={langStore.groupThemeLabel}
            collapsible={false}
          >
            <FormControl fullWidth>
              <ShowMultiLine value={name} label={langStore.ThemeNameLabel} />
              <ShowBoolean value={active} label={langStore.ThemeActiveLabel} />
              <InputCodeEditor
                value={authoring}
                onChange={() => {}}
                label={langStore.ThemeAuthoringLabel}
                language="json"
                readOnly={true}
              />
              <InputCodeEditor
                value={resolved}
                onChange={() => {}}
                label={langStore.ThemeResolvedLabel}
                language="json"
                readOnly={true}
              />
            </FormControl>
          </GroupContainer>
        </Box>
      </Grid>
    );
  }
);
